import React from "react";
import styled from "styled-components";
import { Icon, IconName } from "@literati/public-ui-shared-react";

const SavingsGraf = styled.p`
  background-color: #eff2ff;
  border-radius: 8px;
  padding: 20px;
  font-size: 0.9rem;
`;

const StyledIcon = styled(Icon)`
  display: inline-block;
  margin-right: 16px;
`;

export type TotalSavingsProps = {
  savings: string;
  isPast?: boolean;
};

const TotalSavings = ({ isPast, savings }: TotalSavingsProps) => {
  if (!savings || savings == "$0.00") {
    return null;
  }
  return (
    <SavingsGraf>
      <StyledIcon name={IconName.RAINBOW} />
      You {isPast ? "saved" : "save"} <strong>{savings}</strong> by being a
      Literati member!
    </SavingsGraf>
  );
};

export default TotalSavings;
